import React, { useState } from 'react'
import './GradientBarChart.css'
import { OtherText, ParagraphText } from 'styling/Typography'
import { Flex } from 'styling/GlobalStyles'
import { RootState } from 'store'
import { useSelector } from 'react-redux'

export const GradientBarChart = ({ data, height, showLabels, percentage }: IGradientBarChart) => {
  const maxValue = Math.max(...data.map((d) => d.value))
  const [hoveredBar, setHoveredBar] = useState(null)
  const gridLines = 5
  const { darkMode: isDarkMode } = useSelector((state: RootState) => state.globals)

  const getGradientStyle = (color: string) => {
    if (isDarkMode) {
      return `linear-gradient(180deg, ${color} 0%, #000000 180%)`
    } else {
      return `linear-gradient(180deg, ${color} 0%, ${color} 180%)`
    }
  }

  return (
    <Flex column gap='10px' style={{ height: height ?? '100%' }}>
      <div className='chart-wrapper'>
        <div className='y-axis'>
          {Array.from({ length: gridLines + 1 }).map((_, idx) => (
            <OtherText key={idx} style={{ opacity: '0.5' }}>
              {Math.round((maxValue / gridLines) * (gridLines - idx))}
              {percentage && '%'}
            </OtherText>
          ))}
        </div>

        <div className='chart-container' style={{ height: height ?? '100%' }}>
          {data.map((item, idx) => {
            const barHeight = (item.value / maxValue) * 100
            const gradientStyle = getGradientStyle(item.color || '#FF9900')

            return (
              <div
                key={idx}
                className='bar-wrapper'
                onMouseEnter={() => setHoveredBar(idx)}
                onMouseLeave={() => setHoveredBar(null)}
                style={{
                  height: `${barHeight}%`,
                }}
              >
                {hoveredBar === idx && (
                  <div className='tooltip'>
                    <span className='tooltip-name'>{item.name}</span>
                    <span className='tooltip-value'>{item.value}</span>
                  </div>
                )}
                <div
                  className='bar'
                  style={{
                    height: '100%',
                    background: gradientStyle,
                  }}
                />
              </div>
            )
          })}
        </div>
      </div>
      {showLabels && (
        <div className='labels-container'>
          {data.map((l, i) => (
            <ParagraphText key={i}>{l.name}</ParagraphText>
          ))}
        </div>
      )}
    </Flex>
  )
}

interface IGradientBarChart {
  data: {
    value: number
    name: string
    color: string
  }[]
  height?: number
  showLabels?: boolean
  percentage?: boolean
  isDarkMode?: boolean
}
